import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { MODULE_SUMMARY_TABLE_SVGS, TOC_MODULE_COLORS } from "./constants.js";
const SVG_W = 650;
const SVG_H = 672;
function ChapterBubble({
  number,
  accentColor
}) {
  return /* @__PURE__ */ jsxs("div", { style: { position: "relative", width: 374, height: 247 }, children: [
    /* @__PURE__ */ jsx(
      "div",
      {
        style: {
          position: "absolute",
          left: 6,
          top: 11,
          width: 125,
          height: 90,
          borderRadius: 64,
          background: "#1B2559",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 2
        },
        children: /* @__PURE__ */ jsx(
          "span",
          {
            className: "font-dunggeunmiso",
            style: { fontSize: 34, color: "#fff", fontWeight: 700, lineHeight: "normal" },
            children: "챕터"
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      "div",
      {
        style: {
          position: "absolute",
          left: 62,
          top: 37,
          width: 250,
          height: 170,
          borderRadius: 125,
          background: "#FFFEFE",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1
        },
        children: /* @__PURE__ */ jsx(
          "span",
          {
            className: "font-dunggeunmiso",
            style: { fontSize: 110, color: accentColor, fontWeight: 700, lineHeight: "normal" },
            children: number
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      "svg",
      {
        width: "70",
        height: "50",
        viewBox: "0 0 70 50",
        fill: "none",
        style: { position: "absolute", left: 207, top: 190, zIndex: 0 },
        children: /* @__PURE__ */ jsx(
          "path",
          {
            d: "M0 5 C5 0 18 0 28 12 C38 28 52 40 65 48 C48 38 32 32 18 28 C8 25 2 18 0 5 Z",
            fill: "#FFFEFE"
          }
        )
      }
    )
  ] });
}
function LessonListItem({
  number,
  lessonName,
  accentColor
}) {
  const numStr = String(number).padStart(2, "0");
  return /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: 10, fontSize: 18, lineHeight: "26px" }, children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        style: {
          display: "flex",
          alignItems: "center",
          height: 26,
          fontFamily: "'Pretendard', sans-serif",
          fontWeight: 700,
          color: accentColor,
          textAlign: "center",
          flexShrink: 0
        },
        children: [
          /* @__PURE__ */ jsx("span", { style: { width: 12, display: "inline-block", textAlign: "center" }, children: numStr[0] }),
          /* @__PURE__ */ jsx("span", { style: { width: 12, display: "inline-block", textAlign: "center" }, children: numStr[1] })
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      "span",
      {
        style: {
          fontFamily: "'Pretendard', sans-serif",
          fontWeight: 400,
          color: "#000",
          whiteSpace: "nowrap",
          flexShrink: 0
        },
        children: lessonName
      }
    )
  ] });
}
function ModuleSummaryPage({
  moduleIndex,
  moduleName,
  colorIndex,
  lessons,
  pageWidth,
  pageHeight,
  bleedPx = 0
}) {
  const ci = colorIndex ?? Math.min(moduleIndex, 2);
  const tableSvg = MODULE_SUMMARY_TABLE_SVGS[ci] || MODULE_SUMMARY_TABLE_SVGS[0];
  const accentColor = TOC_MODULE_COLORS[ci] || TOC_MODULE_COLORS[0];
  const totalW = pageWidth + bleedPx * 2;
  const totalH = pageHeight + bleedPx * 2;
  const svgLeft = (totalW - SVG_W) / 2;
  const svgTop = (totalH - SVG_H) / 2;
  const pageStyle = {
    position: "relative",
    overflow: "hidden",
    boxSizing: "border-box",
    width: totalW,
    height: totalH,
    background: accentColor
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: "print-page", style: pageStyle, children: [
      /* @__PURE__ */ jsx(
        "div",
        {
          style: {
            position: "absolute",
            left: "50%",
            top: "calc(50% - 169px)",
            transform: "translate(-50%, -50%)",
            width: 374,
            height: 247
          },
          children: /* @__PURE__ */ jsx(ChapterBubble, { number: moduleIndex + 1, accentColor })
        }
      ),
      /* @__PURE__ */ jsx(
        "p",
        {
          className: "font-dunggeunmiso",
          style: {
            position: "absolute",
            left: "50%",
            top: "calc(50% + 35px)",
            transform: "translateX(-50%)",
            width: 650,
            height: 188,
            margin: 0,
            fontSize: 72,
            fontWeight: 700,
            color: "#fff",
            textAlign: "center",
            lineHeight: 1.3,
            letterSpacing: "3.6px"
          },
          children: moduleName
        }
      )
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "print-page", style: pageStyle, children: [
      /* @__PURE__ */ jsx(
        "img",
        {
          src: tableSvg,
          alt: "",
          style: {
            position: "absolute",
            left: svgLeft,
            top: svgTop,
            width: SVG_W,
            height: SVG_H,
            pointerEvents: "none"
          }
        }
      ),
      /* @__PURE__ */ jsx(
        "div",
        {
          style: {
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            width: 360,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 10
          },
          children: lessons.map((lesson, i) => /* @__PURE__ */ jsxs("div", { style: { width: "100%", display: "flex", flexDirection: "column", gap: 10 }, children: [
            /* @__PURE__ */ jsx(
              LessonListItem,
              {
                number: i + 1,
                lessonName: lesson.lessonName,
                accentColor
              }
            ),
            i < lessons.length - 1 && /* @__PURE__ */ jsx("div", { style: { width: "100%", height: 0, borderTop: "1px dotted #d4d4d4" } })
          ] }, i))
        }
      )
    ] })
  ] });
}
export {
  ModuleSummaryPage
};
//# sourceMappingURL=ModuleSummaryPage.js.map
